// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const objToEncodedString = (obj: any): string =>
	btoa(encodeURIComponent(JSON.stringify(obj)));
